export default {"src":"/_next/static/media/super-sku-tooltip.1926f324.svg","height":16,"width":16};